import { FindSimpleDeviceListByPage } from '@/axios/IDevice.js'
import { warning } from '@/assets/js/common.js'

/**
 * 校验房间是否满足控制区域绑定条件
 * @returns {Promise<boolean>} true 放行，false 阻塞
 */
export function validateCurrentRoom(vm, gpNo, device) {
  return FindSimpleDeviceListByPage({
    needDeviceGroup: false,
    gpNos: gpNo,
    gpNo,
    childCategoryType: 2,
    pageIndex: 1,
    pageSize: 9999,
  }).then(res => {
    const lightDevices = res?.Result?.RecordList || []
    const knobGatewayId = device?.GatewayDeviceId

    // 3. 房间下没灯具，阻塞
    if (lightDevices.length === 0) {
      warning(vm, vm.$t('controlArea.bindRoomError3'))
      return false
    }

    // 非 wifi 灯具
    const subLightDevices = lightDevices.filter(item => {
      const vId = item.VDeviceId
      const pId = item.ParentVDeviceId
      return vId != pId
    })

    // 4. 全是 wifi 设备，直接放行
    if (subLightDevices.length === 0) {
      return true
    }

    const sameLightDevices = subLightDevices.filter(item => {
      const gatewayId = item.GatewayDeviceId
      return gatewayId == knobGatewayId
    })

    // 1. 全部灯具和旋钮都不在一个网关，阻塞
    if (sameLightDevices.length === 0) {
      warning(vm, vm.$t('controlArea.bindRoomError2'))
      return false
    }

    // 都在同一网关
    if (sameLightDevices.length === subLightDevices.length) {
      return true
    }

    // 2. 部分灯具和旋钮不在一个网关，允许
    const noSameLightDevices = subLightDevices.filter(item => {
      const gatewayId = item.GatewayDeviceId
      return gatewayId != knobGatewayId
    })
    const names = noSameLightDevices.map(item => item.DeviceName || item.name || '').join(',')
    warning(vm, vm.$t('controlArea.bindRoomError1', { names }))
    return true
  })
}
